import type {FC} from 'react'
import {Typography} from '@mui/material'
import {useCustomTranslation} from '@hooks/useCustomTranslation.ts'

/**
 * The AI disclosure that sits under the Alpinist title in a chat header.
 *
 * Art. 50(1)/50(5) of the EU AI Act require the person to be told they are
 * talking to an AI system, clearly and no later than the first interaction —
 * so this is chrome, not a message: it renders before anything is sent and
 * stays for the whole conversation.
 *
 * Every chat header that shows `AlpinistTitle` should show this beneath it,
 * which is why the copy and styling live here rather than in each header.
 * Deliberately not dismissible and not aria-hidden: a notice the user can turn
 * off, or that a screen reader skips, stops being a disclosure. It also must
 * not wrap — the copy is kept to ~35 characters in every locale so it stays on
 * one line at side-panel width.
 */
export const AlpinistDisclosure: FC = () => {
  const [t] = useCustomTranslation('alpinist')

  return (
    <Typography
      component="p"
      color="text.secondary"
      sx={{fontSize: 11, lineHeight: 1.2, opacity: 0.7, whiteSpace: 'nowrap', userSelect: 'none'}}
    >
      {t('ai_disclosure')}
    </Typography>
  )
}
